export enum ChallengeTypeEnum {
  FORMATION = 1,
  TALK = 2,
  CAMPAIGN = 3,
  ANNUAL_CAMPAIGN = 4,
  EXPERIENCE = 5,
  PEARL = 6,
  CONTEST = 7,
  DONATION = 8,
  CONGRESS = 9,
  FORMATION_CON = 10,
}
